import { useLocation } from "react-router";
import { Box, Button, Popover, useTheme } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import IndustriesMenu from "../IndustriesMenu";
import ResourcesMenu from "../ResourcesMenu";
import SolutionsMenu from "../SolutionsMenu";
import TechnologyMenu from "../TechnologyMenu";
import { getButtonStyles, getDropDownMenuStyles } from "./styles";

interface IProps {
  title: string;
  path: string;
  activeMenu: string | null;
  anchorElDropDown: null | HTMLElement;
  openDropDown: (event: React.MouseEvent<HTMLElement>, path: string) => void;
  closeDropDown: () => void;
}

const DropDownMenu: React.FC<IProps> = ({
  title,
  path,
  anchorElDropDown,
  openDropDown,
  closeDropDown,
  activeMenu,
}) => {
  const { pathname } = useLocation();
  const mainRoute = location.pathname.split("/")[1];
  const isActiveLink =
    activeMenu === path ||
    pathname === path ||
    (mainRoute === "industries" && `/${mainRoute}` === path);

  const theme = useTheme();
  const isLargeDesktop = useResponsive("up", "xl");

  // const [maxHeight, setMaxHeight] = useState<number>(200);

  // Toggle drop-down menu
  const toggleDropDown = (
    event: React.MouseEvent<HTMLElement>,
    path: string
  ) => {
    if (!anchorElDropDown) {
      openDropDown(event, path);
    } else {
      closeDropDown();
    }
  };

  // useLayoutEffect(() => {
  //   const calculateMaxHeight = () => {
  //     const headerHeight = 200;
  //     setMaxHeight(headerHeight + 12);
  //   };

  //   calculateMaxHeight();

  //   window.addEventListener("resize", calculateMaxHeight);
  //   return () => {
  //     window.removeEventListener("resize", calculateMaxHeight);
  //   };
  // }, []);

  return (
    <>
      <Button
        variant="text"
        aria-controls="drop-down"
        onClick={(event) => {
          toggleDropDown(event, path);
        }}
        sx={getButtonStyles(theme)}
        color={isActiveLink ? "primary" : "secondary"}
        endIcon={
          activeMenu === path ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )
        }
      >
        {title}
      </Button>

      {/* Drop down menu */}
      <Popover
        id="drop-down"
        open={Boolean(anchorElDropDown)}
        keepMounted
        anchorEl={anchorElDropDown}
        onClose={closeDropDown}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{ sx: getDropDownMenuStyles(200, isLargeDesktop) }}
      >
        <Box
          sx={{ maxWidth: "1520px", boxSizing: "border-box" }}
          mx="auto"
          px={2}
          py={0}
        >
          {activeMenu === ROUTES.solutions && (
            <SolutionsMenu closeDropDown={closeDropDown} />
          )}
          {activeMenu === ROUTES.whyTrackmate && (
            <TechnologyMenu closeDropDown={closeDropDown} />
          )}
          {activeMenu === ROUTES.resources && (
            <ResourcesMenu closeDropDown={closeDropDown} />
          )}
          {activeMenu === ROUTES.industries && (
            <IndustriesMenu closeDropDown={closeDropDown} />
          )}
        </Box>
      </Popover>
    </>
  );
};

export default DropDownMenu;
